<template>
  <div class="comment-row-answer">
    <div class="flex">
      <BaseSeparator vertical classes="h-full h-[1px] border-l-[2px] border-primary-200" />
      <div class="comment-row-answer__response">
        <div class="flex">
          <TeacherListItemsAvatar class="lg:w-auto" :show-btn="false" :size="{lg: '48', xs: '40'}" />
          <div class="ml-4">
            <TeacherListItemsName :show-icon="false" :classes="classListTeacher" />
            <span class="comment-row-answer__date">{{ date }}</span>
          </div>
        </div>
        <div class="mt-3 mb-3 text-body-2">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeacherListItemsAvatar from '~/components/common/teacher-list-items/teacher-list-items-avatar'
import TeacherListItemsName from '~/components/common/teacher-list-items/teacher-list-items-name'

export default {
  name: 'BlockCommentRowResponse',
  components: {
    TeacherListItemsAvatar,
    TeacherListItemsName
  },
  props: {
    name: {
      type: String,
      default: 'Teacher\'s answer'
    },
    text: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    }
  },
  computed: {
    classListTeacher () {
      return 'text__caption-xs--bold lg:text__body-2-md--bold text-body-2 text__headline-4-xs--bold'
    }
  }
}
</script>

<style scoped lang="scss">
.comment-row-answer {
  @apply flex ml-10;
  &__date {
    @apply text__caption-1-xs--regular lg:text__body-3-md--regular mt-2;
  }
  &__response {
    @apply ml-3 text__caption-xs--regular lg:text__body-3-md--regular mt-2 text-body-2 ;
  }
  &__pointer {
    @apply absolute top-[-16px] left-[3%] w-0 h-0;
    border-left: 18px solid transparent;
    border-right: 18px solid transparent;
    border-bottom: 30px solid;
    @apply border-b-bg-cart;
  }
}
</style>
